
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
XHeader,
Group,
Cell,
XInput,
XButton,
Selector,
Tabbar,TabbarItem,Drawer,ViewBox
},
data () {
return {
}
},
mounted () {

},
methods: {
payresult0 () {
var _this = this;
var sort = _this.$route.params.sort;
var stunum = _this.$route.params.stunum;
_this.$router.push({name: 'PaySuccess',params:{sort:sort,stunum:stunum}});
},
payresult1 () {
var _this = this;
var sort = _this.$route.params.sort;
var stunum = _this.$route.params.stunum;
_this.$router.push({name: 'PayFailed',params:{sort:sort,stunum:stunum}});
}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/pay.vue